var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerarcontrato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e353b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.92,29.66c-1.02-.44-2.23,.03-2.71,1.03l-5.64,12.57c-3.28-9.1-9.85-16.42-18.56-20.65-8.85-4.3-18.85-4.89-28.15-1.67-9.3,3.22-16.79,9.87-21.08,18.73-4.3,8.85-4.89,18.85-1.67,28.15,5.27,15.22,19.58,24.78,34.85,24.78,3.99,0,8.05-.65,12.03-2.03,1.27-.44,1.94-1.82,1.5-3.09-.44-1.27-1.82-1.94-3.09-1.5-16.66,5.77-34.92-3.09-40.69-19.75-2.8-8.07-2.28-16.75,1.45-24.44,3.73-7.69,10.23-13.46,18.3-16.26,8.07-2.8,16.75-2.28,24.44,1.45,7.69,3.73,13.46,10.23,16.26,18.3,.05,.15,.12,.28,.19,.41l-13.58-6.09c-1.03-.43-2.24,.04-2.72,1.04-.47,1.04-.01,2.24,1.04,2.73l18.07,8.09,.29,.12c.1,.02,.18,.04,.21,.03l.13,.04,.58-.04,.52-.17,.35-.22c.07-.06,.14-.12,.15-.13l.13-.13h0c.09-.11,.15-.19,.16-.23l8.29-18.35c.45-1.06,0-2.26-1.05-2.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerarcontrato);
export default __webpack_public_path__ + "static/media/generarcontrato.323aff293cc59d41230a597819987d6c.svg";
export { ForwardRef as ReactComponent };